(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r9-regua-promo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var instancias = new WeakMap();
  function iniciar(raiz) {
    if (instancias.has(raiz)) return;
    var editor = raiz.dataset.modoEditor === 'true';
    var chave = 'r9-regua-fechada-' + raiz.id;
    var timer, retornoCupom, descartada = false;
    var btnFechar = raiz.querySelector('[data-r9-fechar]');
    var cupom = raiz.querySelector('[data-r9-cupom]');
    var contador = raiz.querySelector('[data-r9-contador]');
    var encerrado = raiz.querySelector('[data-r9-encerrado]');
    function limpar() {
      descartada = true;
      clearInterval(timer);
      clearTimeout(retornoCupom);
      if (btnFechar) btnFechar.removeEventListener('click', fechar);
      if (cupom) cupom.removeEventListener('click', copiar);
      instancias.delete(raiz);
    }
    function fechar() {
      try { sessionStorage.setItem(chave, '1'); }
      catch (erro) { console.warn('[r9-regua] fechamento não persistido:', erro.name); }
      limpar();
      raiz.remove();
    }
    function copiar() {
      var codigo = cupom.getAttribute('data-r9-cupom');
      var acao = cupom.querySelector('[data-r9-cupom-acao]');
      clearTimeout(retornoCupom);
      function informar(texto) {
        if (descartada || !acao) return;
        acao.textContent = texto;
        retornoCupom = setTimeout(function () { acao.textContent = 'copiar'; }, 5000);
      }
      function falhou() { informar('copie à mão'); }
      if (!navigator.clipboard || !navigator.clipboard.writeText) { falhou(); return; }
      navigator.clipboard.writeText(codigo).then(function () { informar('copiado!'); }, falhou);
    }
    instancias.set(raiz, limpar);
    try {
      if (!editor && raiz.dataset.lembrarFechado === 'sim' && sessionStorage.getItem(chave) === '1') {
        limpar(); raiz.remove(); return;
      }
    } catch (erro) { console.warn('[r9-regua] fechamento não consultado:', erro.name); }
    if (btnFechar) btnFechar.addEventListener('click', fechar);
    if (cupom) cupom.addEventListener('click', copiar);

    var fimTxt = (raiz.dataset.fim || '').trim();
    if (!fimTxt) return;
    var m = fimTxt.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})$/);
    var dt = m && new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
    if (!m || dt.getUTCMonth() !== +m[2] - 1 || dt.getUTCDate() !== +m[3] || +m[4] > 23 || +m[5] > 59) {
      if (contador) contador.hidden = true;
      console.warn('[r9-regua] data de fim inválida:', fimTxt);
      return;
    }
    var fim = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4] + 3, +m[5]);
    var elD = raiz.querySelector('[data-r9-dias]'), elH = raiz.querySelector('[data-r9-horas]'),
        elM = raiz.querySelector('[data-r9-min]'), elS = raiz.querySelector('[data-r9-seg]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      if (!raiz.isConnected) { limpar(); return false; }
      var resta = fim - Date.now();
      if (resta <= 0) {
        clearInterval(timer);
        if (raiz.dataset.aoTerminar === 'esconder' && !editor) { limpar(); raiz.remove(); return false; }
        if (contador) contador.hidden = true;
        if (encerrado) encerrado.hidden = false;
        return false;
      }
      if (contador) {
        var s = Math.floor(resta / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var mi = Math.floor(s / 60); s -= mi * 60;
        elD.textContent = pad(d); elH.textContent = pad(h); elM.textContent = pad(mi); elS.textContent = pad(s);
      }
      return true;
    }
    if (tick()) timer = setInterval(tick, 1000);
  }
  function iniciarEm(alvo) { alvo.querySelectorAll('[data-r9-regua]').forEach(iniciar); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { iniciarEm(document); }, { once: true });
  } else { iniciarEm(document); }
  document.addEventListener('shopify:section:load', function (evento) { iniciarEm(evento.target); });
  document.addEventListener('shopify:section:unload', function (evento) {
    evento.target.querySelectorAll('[data-r9-regua]').forEach(function (raiz) {
      var limpar = instancias.get(raiz);
      if (limpar) limpar();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
